import React from 'react'
import injectSheet from 'react-jss'
import styles from './school-nav.styles'
import SchoolNavLink from './school-nav-link/school-nav-link'

const SchoolNav = ({ classes, location, pending }) => {
  return (
    <nav className={classes.container}>
      <ul className={classes.links}>
        <SchoolNavLink path="/school/team">Manage Teachers</SchoolNavLink>
        <SchoolNavLink path="/school/add-pupils">Manage pupils</SchoolNavLink>
        <SchoolNavLink path="/school/edit">Celebration page</SchoolNavLink>
      </ul>
    </nav>
  )
}

export default injectSheet(styles)(SchoolNav)
